import { workshopFiles } from '@/apis/paiban'
import { PartType } from '@/partTypes'
import { uploadFileToOss, uploadJsonToOss } from '@yige/utils'

/**
 * @description 收集一套标准的数据发送到车间
 */
export async function sendDataToWorkShop(payload: {
  address: string
  order_id: string
  product_line: string
  process_line_id: string | number
  plank: PartType[]
  zip: any
  layout_batch?: string
  jsonObj?: any
}) {
  const {
    address,
    order_id,
    product_line,
    process_line_id,
    jsonObj,
    plank,
    layout_batch,
    zip,
  } = payload
  let fileUrl = ''
  if (jsonObj) {
    fileUrl = await uploadJsonToOss(
      { files: [{ jsonObj }] },
      'factoryFiles',
      'bluenMaterialData',
      true
    )
  }
  /** 上传上去作为补件使用 */
  const plankUrl = await uploadJsonToOss(
    {
      plank,
    },
    'plankFiles',
    'bluenMaterialData',
    true
  )
  const zipData = await zip.generateAsync({ type: 'blob' })
  const file = new File([zipData], `${address}.zip`, {
    type: 'application/zip',
  })
  /** 上传完整的NC文件 */
  const fullFileUrl = await uploadFileToOss(
    file,
    undefined,
    undefined,
    'productionWorkShop',
    true
  )
  const result = await workshopFiles({
    address,
    order_id,
    product_data: fullFileUrl,
    product_line,
    /** 新版上传完整文件不再需要此字段，后续某个更新可能改造整个接口 */
    file_url: fileUrl,
    plank_url: plankUrl,
    process_line_id,
    paibanImgArr: [],
    layout_batch,
  })
  return result
}
